import * as React from 'react';

import { IHousesByTurn } from '../../types/newbuilding/housesByTurn';
import { TitleValueList } from '../TitleValueList';
import { convertFinishDateToTitleValue } from './utils/convertFinishDateToTitleValue';

interface IHousesByTurnProps {
  housesByTurn: IHousesByTurn[];
}

export function HousesByTurn({ housesByTurn }: IHousesByTurnProps) {
  return (
    <>
      {housesByTurn.map(({ title, finishDates }) => (
        <TitleValueList key={title} title={title} items={convertFinishDateToTitleValue(finishDates)} />
      ))}
    </>
  );
}
